import { createQueryHook } from '~/shared/providers/api/createQueryHook';

export const useCreateSupplierPermissionQuery = createQueryHook(
  'trade.createSupplierPermission',
  () => ({
    checkUserPermission: {
      __args: {
        input: {
          action: 'accountCreate',
        },
      },
      allowed: true,
      action: true,
      resource: true,
    },
  }),
  {
    select: (data) => data?.checkUserPermission,
  },
);
